import { useRef } from 'react'

interface GapEditorProps {
  editableRef: React.RefObject<HTMLDivElement>
  initialValue?: string
}

export default function GapEditor({ initialValue, editableRef }: GapEditorProps) {
  const markAsGap = () => {
    const selection = window.getSelection()
    if (!selection || selection.rangeCount === 0) return

    const range = selection.getRangeAt(0)
    if (!range || range.collapsed) {
      alert('Please select some text first.')
      return
    }

    const startNode = range.startContainer
    const endNode = range.endContainer

    const isWithinItalic = (node: Node): boolean => {
      if (node.nodeName === 'I') return true
      if (!node.parentNode) return false
      return isWithinItalic(node.parentNode)
    }

    if (isWithinItalic(startNode) || isWithinItalic(endNode)) {
      alert('Cannot mark text that overlaps with existing gaps.')
      return
    }

    const italicElements = range.cloneContents().querySelectorAll('i')
    if (italicElements.length > 0) {
      alert('Cannot mark text that overlaps with existing gaps.')
      return
    }

    const selectedText = selection.toString()

    const italic = document.createElement('i')
    italic.textContent = selectedText

    range.deleteContents()
    range.insertNode(italic)

    selection.removeAllRanges()
  }

  const clearHighlights = () => {
    if (!editableRef.current) return
    const italicElements = editableRef.current.getElementsByTagName('i')
    while (italicElements.length > 0) {
      const italic = italicElements[0]
      const textNode = document.createTextNode(italic.textContent || '')
      italic.parentNode?.replaceChild(textNode, italic)
    }
  }

  const showHtml = () => {
    if (!editableRef.current) return
    console.log(editableRef.current.innerHTML)
  }

  return (
    <div>
      <div
        ref={editableRef}
        contentEditable
        suppressContentEditableWarning
        className="w-full border border-lightBorder/10 rounded-lg p-2 h-[100px] [&>i]:text-coolGray">
        {initialValue
          ?.replace(/<i>/g, '')
          .replace(/<\/i>/g, '')
          .replace(/&nbsp;/g, ' ') || 'Type your sentence here and select text to mark as a gap.'}
      </div>

      <div className="flex gap-2 mt-2">
        <button onClick={markAsGap} className="bg-slateGray text-white rounded-lg px-4 py-2">
          Mark as gap
        </button>
        <button onClick={clearHighlights} className="bg-slateGray text-white rounded-lg px-4 py-2">
          Clear highlights
        </button>
        <button onClick={showHtml} className="bg-slateGray text-white rounded-lg px-4 py-2">
          Show HTML
        </button>
      </div>
    </div>
  )
}
